<template>
  <div>
    <h1 class="headline">Last quarter's results</h1>
    <div class="modal__question">
      <div class="modal__question__text">Q: <div v-html="apiData.question"></div></div>
      <div :class="'modal__results modal__results--' + apiData.type">
        <resultsChart
          v-bind:chartLabels = "this.chartLabels"
          v-bind:dataValues = "this.dataValues"
          v-bind:chartType = "apiData.type"
          :options = "apiData.options"
        ></resultsChart>
      </div>
    </div>
    <div class="modal__comentary" v-html="apiData.commentary"></div>
  </div>
</template>

<script>

import resultsChart from './resultsChart.vue'

export default {
  name: 'ResultsPrevious',
  components: {
    resultsChart
  },
  props: {
    apiData: Object
  },
  computed: {
    dataValues: function () {
      let dataValuesArray = [];
      this.apiData.options.forEach(function(row){
        dataValuesArray.push(row.answer);
      });
      return dataValuesArray;
    },
    chartLabels: function () {
      let chartLabelsArray = [];
      this.apiData.options.forEach(function(row){
        // chartLabelsArray.push(row.text + ': ' + row.value); // Adds values to label
        chartLabelsArray.push(row.text); 
      });
      return chartLabelsArray;
    }
  }
}
</script>